import { useEffect, useRef } from "react";
import { Book, Target } from "lucide-react";
import FormSection from "./FormSection";
import NumberedListInput from "./NumberedListInput";
import RichTextEditor from "./RichTextEditor";
import { SECTION_TYPES } from "../../LessonPlannerConstant";

/**
 * A teacher-defined section: a numbered list ("Lesson Takeaways") or a rich-text
 * block ("Notes"). `isNew` scrolls a just-added section into view and focuses it.
 */
const CustomSectionBlock = ({ section, isNew = false, onChange, onDelete }) => {
  const sectionRef = useRef(null);
  const isList = section.type === SECTION_TYPES.BULLET_LIST;

  useEffect(() => {
    if (!isNew) return;
    sectionRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
    if (isList) sectionRef.current?.querySelector("input")?.focus({ preventScroll: true });
  }, [isNew, isList]);

  return (
    <FormSection
      ref={sectionRef}
      icon={isList ? Target : Book}
      title={section.name}
      subtitle={section.sub_heading}
      onDelete={onDelete}
    >
      {isList ? (
        <NumberedListInput items={section.items} onChange={(items) => onChange({ ...section, items })} />
      ) : (
        <RichTextEditor
          id={`lp-section-${section.uid}`}
          value={section.content}
          autoFocus={isNew}
          onChange={(content) => onChange({ ...section, content })}
        />
      )}
    </FormSection>
  );
};

export default CustomSectionBlock;
